import { SrcQuestionareAnsInpService } from './src-questionare-ans-inp.service';
import { AfterViewChecked, AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import * as _ from 'lodash';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/store/states/app.state';
import { Observable } from 'rxjs';
import { CanComponentDeactivate, DeactivateGuard } from 'src/app/can-deactivate-guard.service';

@Component({
  selector: 'app-src-questionare-ans-inp',
  templateUrl: './src-questionare-ans-inp.component.html',
  styleUrls: ['./src-questionare-ans-inp.component.scss']
})
export class SrcQuestionareAnsInpComponent implements OnInit, AfterViewInit, DeactivateGuard {
  public lstInterviewSheet: any[] = [];
  public dataDisplay: any = {};
  public dataAllSheet: any[] = [];
  public objUserInfo: any;
  public strInterviewContent = '';
  public lstInterviewItem: any[] = [];
  public blnIsChangeData = false;
  public lstItemErr: any[] = [];

  constructor(
    public util: Utility,
    public translate: TranslateService,
    private service: SrcQuestionareAnsInpService,
    private loading: LoadingService,
    private dialogModalService: DialogModalService,
    private router: Router,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
  ) { }

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.blnIsChangeData === true) {
      return false;
    }
    return true;
  }
  setDeactivateState(nextState) {
    if (this.blnIsChangeData === true) {
      const msg = this.translate.instant('MESS_CNF_SAVE_CHANGED');
      this.dialogModalService.openVerificationModal(msg).subscribe(res => {
        if (res.isOk()) {
          this.onClickBtnRegis(nextState);
        } else if (res.isNo()) {
          this.blnIsChangeData = false;
          this.router.navigateByUrl(nextState);
        }
      });
    }
  }
  canDeactivate(
    component: CanComponentDeactivate, route: ActivatedRouteSnapshot, state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean>| Promise<boolean> | boolean {
      return this.blnIsChangeData === false;
  }

  ngOnInit(): void {
    // get user info
    this.util.resetZoomBrowser();
    this.objUserInfo = {
      HTOrgCode: this.routeActived.snapshot.queryParams.htorgcode,
      RsvDate: this.routeActived.snapshot.queryParams.rsvdate,
      RsvNum: this.routeActived.snapshot.queryParams.rsvnum
    };
    this.getHTOrgInfo();
    const srtUser = localStorage.getItem('ExamineauthorizationData');
    if (srtUser) {
      this.objUserInfo.UserID = JSON.parse(srtUser)?.UserID;
    } else {
      this.router.navigate(['login'], { queryParams: { htorgcode: this.objUserInfo.HTOrgCode }});
    }
    this.getAllSheetData();
    $('.wrapper-body').scroll(function() {
      const hT = $('#btn-bottom').position()?.top;
      const hH = $('#btn-bottom').outerHeight();
      const wH = $('.wrapper-body').height();
      const wS = $(this).scrollTop();
      if (wS > (hT + hH - wH)){
          $(this).addClass('hiden-btn-fixed');
      } else {
          $(this).removeClass('hiden-btn-fixed');
      }
    });
    $('.wrapper-body').animate({scrollTop: 0}, 0);
    setTimeout(() => {
      this.setRowAnswer();
    }, 1000);
  }

  hideFixedBtn() {
    setTimeout(() => {
      if ($('.wrapper-reponsive.pos-relative').height() <= $('.wrapper-body').height()) {
        $('.wrapper-body').addClass('hiden-btn-fixed');
      } else {
        $('.wrapper-body').removeClass('hiden-btn-fixed');
      }
    }, 100);
  }

  setHTOrgNameOnHeader(pHTOrgCode, pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: pHTOrgCode,
      HTOrgName: pHTOrgName
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }

  getHTOrgInfo() {
    this.service.getHTOrgInfo(this.routeActived.snapshot.queryParams.htorgcode).subscribe(res => {
      if (res) {
        this.setHTOrgNameOnHeader(this.objUserInfo?.HTOrgCode, res?.HTOrgName?.trim());
      }
    });
  }

  getAllSheetData() {
    const objParam = {
      HTOrgCode: this.objUserInfo.HTOrgCode,
      RsvDate: this.objUserInfo.RsvDate,
      RsvNum: this.objUserInfo.RsvNum,
      UserID: this.objUserInfo.UserID
    };
    this.loading.setDisplay(true);
    this.service.getInterviewSheetInfo(objParam).subscribe(res => {
      this.loading.setDisplay(false);
      if (res && res.length > 0) {
        // res.forEach(sheet => {
        //   sheet.DispNum = Number(sheet.DispNum) || 999;
        //   this.dataAllSheet.push(this.setDataDisplay(sheet));
        // });
        // res = _.orderBy(res, 'DispNum');
        // this.setHTOrgNameOnHeader(this.objUserInfo.HTOrgCode, res[0].HTOrgName?.trim());
        // this.lstInterviewSheet = res;
        // this.strInterviewContent = res[0].InterviewContent?.trim();
        // this.onSelectInterviewSheet(res[0], true);
        // this.setDataRegis();
        let result =  res.filter((v, i, s) => (i === s.findIndex((t) => {
          return t.InterviewSheetCode === v.InterviewSheetCode
              && t.InterviewSheetName === v.InterviewSheetName
        })));
        result.forEach(sheet => {
          sheet.DispNum = Number(sheet.DispNum) || 999;
          this.dataAllSheet.push(this.setDataDisplay(sheet));
        });
        result = _.orderBy(result, 'DispNum');
        this.setHTOrgNameOnHeader(this.objUserInfo.HTOrgCode, result[0].HTOrgName?.trim());
        this.lstInterviewSheet = result;
        this.strInterviewContent = result[0].InterviewContent?.trim();
        this.onSelectInterviewSheet(result[0], true);
        this.setDataRegis();
      }
    },
    error => {
      this.loading.setDisplay(false);
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
    });
  }

  onSelectInterviewSheet(pInterviewSheetSelected, blnIsInit = false) {
    // check up-low limit
    if (!blnIsInit) {
      if (this.checkValidLimitInsideCurrentSheet() === false) {
        this.scrollToTopItemErr();
        return;
      } else {
        $('.wrapper-body').scrollTop(0);
      }
    }
    this.hideFixedBtn();
    pInterviewSheetSelected.active = true;
    this.lstInterviewSheet.filter(x => x.InterviewSheetCode !== pInterviewSheetSelected.InterviewSheetCode).forEach(item => {
      item.active = false;
    });
    this.dataDisplay = this.dataAllSheet?.find(x => x.InterviewSheetCode === pInterviewSheetSelected.InterviewSheetCode);
  }

  setDataDisplay(pRawSheetData) {
    const dataDisplay: any = {};
    dataDisplay.InterviewSheetCode = pRawSheetData.InterviewSheetCode;
    dataDisplay.ParentChildResults = pRawSheetData.ParentChildResults;
    dataDisplay.LstGrp = [];
    const lstInterviewGroupCode = _.uniq(_.map(pRawSheetData.ItemResults, 'InterviewGroupCode'));
    lstInterviewGroupCode.forEach(grpCode => {
      const firstEle = pRawSheetData.ItemResults.find(x => x.InterviewGroupCode === grpCode);
      const lstItemOfGrp = pRawSheetData.ItemResults.filter(x => x.InterviewGroupCode === grpCode);
      const interviewGrpData: any = {};
      interviewGrpData.lstItem = [];
      interviewGrpData.lstItemDisp = [];
      interviewGrpData.lstSetItem = [];
      interviewGrpData.InterviewGroupCode = grpCode?.trim();
      interviewGrpData.InterviewGroupName = firstEle?.InterviewGroupName;
      interviewGrpData.Explanation = firstEle?.Explanation;
      interviewGrpData.LayoutDiv = firstEle?.LayoutDiv?.trim();
      interviewGrpData.InputCheckDiv = firstEle?.InputCheckDiv?.trim();
      const lstItemCodeByGrp = _.uniq(_.map(lstItemOfGrp, 'InterviewItemCode'));
      lstItemCodeByGrp.forEach(itemCode => {
        const firstItem = lstItemOfGrp.find(x => x.InterviewItemCode === itemCode);
        const lstItemGrp = lstItemOfGrp.filter(x => x.InterviewItemCode === itemCode);
        const item: any = {};
        item.InterviewItemCode = firstItem?.InterviewItemCode?.trim();
        item.InterviewItemName = firstItem?.InterviewItemName;
        //20231019 add #20803 start
        item.SupplementExplanation = firstItem?.SupplementExplanation;
        //20231019 add #20803 end
        item.InterviewSetItemCode = firstItem?.InterviewSetItemCode?.trim();
        item.InterviewSetItemName = firstItem?.InterviewSetItemName;
        item.InterviewItemType = firstItem?.InterviewItemType?.trim();
        item.InterviewResultType = firstItem?.InterviewResultType?.trim();
        item.ResultCode = firstItem?.ResultCode?.trim();
        item.ResultValue = firstItem?.ResultValue?.trim();
        item.InteviewResult = firstItem?.InteviewResult?.trim();
        item.UnitName = firstItem?.UnitName;
        item.ResultCategory = firstItem?.ResultCategory?.trim();
        item.ResultColumnNum = firstItem?.ResultColumnNum?.trim();
        item.InputLoLimit = firstItem?.InputLoLimit?.trim();
        item.InputUpLimit = firstItem?.InputUpLimit?.trim();
        item.IsNumberOnly =
          !this.util.isNullOrEmpty(firstItem?.InputLoLimit?.trim()) || !this.util.isNullOrEmpty(firstItem?.InputUpLimit?.trim());
        // item.lstResult = lstItemGrp.map(x => ({
        //   ResultCode: x.ResultCode?.trim(),
        //   ResultValue: x.ResultValue?.trim()
        // }));
        let lstResult = lstItemGrp.filter((v, i, s) => (i === s.findIndex((t) => (t.ResultCode === v.ResultCode && t.ResultValue === v.ResultValue))));
        item.lstResult = lstResult.map(x => ({
          ResultCode: x.ResultCode?.trim(),
          ResultValue: x.ResultValue?.trim()
        }));

        // check parent-child item:
        item.IsDisable = false;
        const lstParent = pRawSheetData.ParentChildResults.filter(x => x.ParentInterviewItemCode?.trim() === item.InterviewItemCode);
        if (lstParent.length > 0) {
          item.IsParent = true;
          item.lstParentResultCode = lstParent.map(x => ({
            ChildItemCode: x.ChildInterviewItemCode?.trim(),
            ParentResultCode: x.ParentInterviewResultCode?.trim()
          }));
        }
        const lstChild = pRawSheetData.ParentChildResults.filter(x => x.ChildInterviewItemCode?.trim() === item.InterviewItemCode);
        if (lstChild.length > 0) {
          item.IsDisable = true;
          for (const child of lstChild) {
            const objParent = pRawSheetData.ItemResults.find(x => x.InterviewItemCode?.trim() === child?.ParentInterviewItemCode?.trim());
            if (objParent !== null && objParent !== undefined
              && objParent.InteviewResult?.trim() === child?.ParentInterviewResultCode?.trim()) {
              item.IsDisable = false;
              break;
            }
          }
        }
        interviewGrpData.lstItem.push(item);
      });
      interviewGrpData.ItemType4 = interviewGrpData.lstItem.find(x => x.InterviewItemType?.trim() === '4');

      // item type 5
      interviewGrpData.lstItemType5 = interviewGrpData.lstItem.filter(x => x.InterviewItemType?.trim() === '5');
      if (interviewGrpData.lstItemType5.length > 0
        && interviewGrpData.InterviewGroupCode !== '05' && interviewGrpData.InterviewGroupCode !== '06') {
        interviewGrpData.lstItemType5 = [interviewGrpData.lstItemType5[0]];
      }
      interviewGrpData.lstItemDisp =
        interviewGrpData.lstItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2' || x.InterviewItemType === '3');

      // LayoutDiv === '1'
      if (interviewGrpData.LayoutDiv === '1') {
        interviewGrpData.lstItemDisp.forEach((item, idx) => {
          item.DispNum = idx;
        });
        const lstSet = interviewGrpData.lstItemDisp.filter(x => !this.util.isNullOrEmpty(x?.InterviewSetItemCode));
        interviewGrpData.lstItemDisp = interviewGrpData.lstItemDisp.filter(x => this.util.isNullOrEmpty(x?.InterviewSetItemCode));
        if (lstSet.length > 0) {
          const lstSetItemCodeByGrp = _.uniq(_.map(lstSet, 'InterviewSetItemCode'));
          lstSetItemCodeByGrp.forEach(setItemCode => {
            if (!this.util.isNullOrEmpty(setItemCode)) {
              const objSet: any = {};
              objSet.lstItem = interviewGrpData.lstItem.filter(x => x.InterviewSetItemCode === setItemCode);
              objSet.InterviewSetItemCode = setItemCode;
              objSet.DispNum = objSet.lstItem[0].DispNum;
              objSet.InterviewSetItemName = objSet.lstItem[0].InterviewSetItemName;
              objSet.InterviewSetItemName = objSet.lstItem[0].InterviewSetItemName;
              interviewGrpData.lstItemDisp.push(objSet);
              interviewGrpData.lstSetItem.push(objSet.lstItem);
            }
          });
          interviewGrpData.lstItemDisp = _.orderBy(interviewGrpData.lstItemDisp, 'DispNum');
        }
      }

      // LayoutDiv === '2'
      if (interviewGrpData.LayoutDiv === '2') {
        interviewGrpData.lstItemDisp = interviewGrpData.lstItem.filter(x => x.InterviewItemType === '2');
        const intNumOfItemsCol1 = Math.ceil(interviewGrpData.lstItemDisp.length / 2);
        let intDispNumCol1 = 0;
        let intDispNumCol2 = 1;
        interviewGrpData.lstItem.forEach((item, idx) => {
          if (item.InterviewItemType !== '2') {
            item.DispNum = interviewGrpData.lstItem.length + 10;
          } else {
            if (idx <= intNumOfItemsCol1 - 1) {
              item.DispNum = intDispNumCol1;
              intDispNumCol1 += 2;
            } else {
              item.DispNum = intDispNumCol2;
              intDispNumCol2 += 2;
            }
          }
        });
        interviewGrpData.lstItem = _.orderBy(interviewGrpData.lstItem, 'DispNum');
      }

      // LayoutDiv === '3'
      if (interviewGrpData.LayoutDiv === '3') {
        interviewGrpData.lstItemDisp = interviewGrpData.lstItem.filter(x => x.InterviewItemType === '1');
      }

      // LayoutDiv === '4' || LayoutDiv === '5'
      if (interviewGrpData.LayoutDiv === '4' || interviewGrpData.LayoutDiv === '5') {
        interviewGrpData.lstItemDisp = interviewGrpData.lstItem.filter(x => x.InterviewItemType === '2');
        const lstSetItemCodeByGrp = _.uniq(_.map(interviewGrpData.lstItemDisp, 'InterviewSetItemCode'));
        lstSetItemCodeByGrp.forEach(setItemCode => {
          if (!this.util.isNullOrEmpty(setItemCode)) {
            interviewGrpData.lstSetItem.push(
              interviewGrpData.lstItem.filter(x => x.InterviewSetItemCode === setItemCode)
            );
          }
        });
      }
      dataDisplay.LstGrp.push(interviewGrpData);
    });
    return dataDisplay;
  }

  onChangeNotApplyCk(pEvent, pGrp) {
    // 20240729 #22635 modify start
    // if (pEvent.target.checked === true) {
    //   pGrp.ItemType4.InteviewResult = pGrp.ItemType4.ResultCode;
    //   pGrp.lstItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
    //     item.InteviewResult = '';
    //     this.setItemValueRegis(item);
    //   });
    //   pGrp.lstSetItem.forEach(setItem => {
    //     setItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
    //       item.InteviewResult = '';
    //       this.setItemValueRegis(item);
    //     });
    //   });
    // } else {
    //   pGrp.ItemType4.InteviewResult = '';
    // }
    // 20241021 #22635 modify start
    // const InterviewRes = pGrp.lstItemDisp?.map(item => {item.InteviewResult = '';});
    // if(InterviewRes?.length == pGrp.lstItem?.length)
    // {
    //   pEvent.target.checked === false;
    // }
    // if (pEvent.target.checked === true) {
    //   this.dialogModalService.openConfirmModal(this.translate.instant('MESS_INFO_CLEAR').replace('{0}', pGrp.InterviewGroupName)).subscribe(cnf => {
    //     if (cnf.buttonName === "ok") {
    //       pGrp.ItemType4.InteviewResult = pGrp.ItemType4.ResultCode;
    //       pGrp.lstItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
    //         item.InteviewResult = '';
    //         this.setItemValueRegis(item);
    //       });
    //       pGrp.lstSetItem.forEach(setItem => {
    //         setItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
    //           item.InteviewResult = '';
    //           this.setItemValueRegis(item);
    //         });
    //       });
    //       pGrp.lstItemType5.forEach(setItem => {
    //         setItem.InteviewResult = '';
    //           this.setItemValueRegis(setItem);
    //       });
    //     } else {
    //       pGrp.ItemType4.InteviewResult = '';
    //       pEvent.target.checked = false;
    //     }
    // });
    // }
    if (pEvent.target.checked === true) {
      let isUpdate = pGrp.lstItem.some((i) => i.InteviewResult != '' && i.InterviewItemType != '4');
      if (isUpdate) {
        this.dialogModalService.openConfirmModal(this.translate.instant('MESS_INFO_CLEAR').replace('{0}', pGrp.InterviewGroupName)).subscribe(cnf => {
          if (cnf.buttonName === "ok") {
            pGrp.ItemType4.InteviewResult = pGrp.ItemType4.ResultCode;
            /* 20250210 #24349 add start */
            this.lstInterviewItem.filter(x => x.InterviewItemCode == pGrp.ItemType4.InterviewItemCode)[0].ResultValue = pGrp.ItemType4.InteviewResult;
            /* 20250210 #24349 add end */
            pGrp.lstItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
              item.InteviewResult = '';
              this.setItemValueRegis(item);
            });
            pGrp.lstSetItem.forEach(setItem => {
              setItem.filter(x => x.InterviewItemType === '1' || x.InterviewItemType === '2').forEach(item => {
                item.InteviewResult = '';
                this.setItemValueRegis(item);
              });
            });
            pGrp.lstItemType5.forEach(setItem => {
              setItem.InteviewResult = '';
                this.setItemValueRegis(setItem);
            });
          } else {
            pGrp.ItemType4.InteviewResult = '';
            pEvent.target.checked = false;
          }
      });
      }
      // 20241030 #22635 add start
      else{
        pGrp.ItemType4.InteviewResult = '1';
      }
      // 20241030 #22635 add end
    }
    // 20241021 #22635 modify start
    // 20240729 #22635 modify end
    /* 20250210 #24349 add start */
    else {
      pGrp.ItemType4.InteviewResult = '';
    }
    this.lstInterviewItem.filter(x => x.InterviewItemCode == pGrp.ItemType4.InterviewItemCode)[0].ResultValue = pGrp.ItemType4.InteviewResult;
    /* 20250210 #24349 add end */
  }

  onChangeItemType1(pEvent, pGrp, pItem) {
    pItem.InteviewResult = pEvent.target.value;
    if (pGrp.ItemType4 !== null && pGrp.ItemType4 !== undefined) {
      pGrp.ItemType4.InteviewResult = '';
      this.setItemValueRegis(pGrp.ItemType4);
    }
    this.setItemValueRegis(pItem);
    this.setShowHideChildItem(pItem, pEvent.target.value?.trim());
  }

  onChangeItemType2(pEvent, pGrp, pItem) {
    if (pEvent.target.checked === true) {
      pItem.InteviewResult = pItem.ResultCode;
      if (pGrp.ItemType4 !== null && pGrp.ItemType4 !== undefined) {
        pGrp.ItemType4.InteviewResult = '';
        this.setItemValueRegis(pGrp.ItemType4);
      }
    } else {
      pItem.InteviewResult = '';
    }
    this.setItemValueRegis(pItem);
    this.setShowHideChildItem(pItem, pItem.InteviewResult);
  }

  setShowHideChildItem(pItem, pParentVal) {
    if (pItem.IsParent === true) {
      let lstChildCode =
        pItem.lstParentResultCode.filter(x => x.ParentResultCode === pParentVal).map(x => x.ChildItemCode);
      if (lstChildCode.length === 0) {
        lstChildCode = _.uniq(pItem.lstParentResultCode.map(x => x.ChildItemCode));
      }
      if (lstChildCode.length > 0) {
        for (const grp of this.dataDisplay.LstGrp) {
          for (const item of grp.lstItem) {
            for (const childCode of lstChildCode) {
              if (item.InterviewItemCode === childCode) {
                // find all parent
                const lstParent =
                  this.dataDisplay.ParentChildResults.filter(x => x.ChildInterviewItemCode?.trim() === item.InterviewItemCode);
                let isDisableChild = true;
                for (const parent of lstParent) {
                  const parentItem = this.lstInterviewItem.find(x => x.InterviewItemCode === parent.ParentInterviewItemCode?.trim());
                  if (parentItem?.ResultValue === parent?.ParentInterviewResultCode?.trim()) {
                    isDisableChild = false;
                  }
                }
                item.IsDisable = isDisableChild;
                if (isDisableChild === true) {
                  item.InteviewResult = '';
                  this.setItemValueRegis(item);
                }
              }
            }
          }
        }
      }
    }
  }

  onClickBtnRegis(url: any) {
    if (this.checkValidLimitInsideCurrentSheet() === false) {
      this.scrollToTopItemErr();
      return;
    }
    const objParam = {
      HTOrgCode: this.objUserInfo.HTOrgCode,
      RsvDate: this.objUserInfo.RsvDate,
      RsvNum: this.objUserInfo.RsvNum,
      InterviewContent: this.strInterviewContent,
      IsInputAllSheet: this.checkIsInputAllSheetByInputCheckDiv(),
      InterviewItems: this.lstInterviewItem
    };
    this.loading.setDisplay(true);
    this.service.registSheetInfo(objParam).subscribe(res => {
      this.loading.setDisplay(false);
      if (res && res === true) {
        this.blnIsChangeData = false;
        this.dialogModalService.openSuccessModal(this.translate.instant('MESS_CMN_INF_REGIS_SUCCESS'));
        setTimeout(() => {
          this.router.navigateByUrl(url);
        }, 1500);
      } else {
        this.dialogModalService.openErrorModal(this.translate.instant('MESS_EXCEPTION_OCCURRED'));
      }
    },
    error => {
      this.loading.setDisplay(false);
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
    });
  }

  checkValidLimitInsideCurrentSheet() {
    this.lstItemErr = [];
    let blnIsValid = true;
    const lstItemNeedCheck = this.lstInterviewItem.filter(x =>
      x.InterviewSheetCode === this.dataDisplay.InterviewSheetCode
      && x.InterviewResultType === '1'
      && (x.InterviewItemType === '3' || x.InterviewItemType === '5')
      && !this.util.isNullOrEmpty(x.ResultValue)
      && !isNaN(Number(x.ResultValue))
      &&  (
            (!this.util.isNullOrEmpty(x.InputLoLimit) && !isNaN(Number(x.InputLoLimit)))
            || (!this.util.isNullOrEmpty(x.InputUpLimit) && !isNaN(Number(x.InputUpLimit)))
          )
    );
    if (lstItemNeedCheck.length > 0) {
      for (const itemCheck of lstItemNeedCheck) {
        let lstItemOfSheet = [];
        this.dataDisplay.LstGrp.forEach(grp => {
          lstItemOfSheet = lstItemOfSheet.concat(grp.lstItem);
        });
        const itemDisp = lstItemOfSheet.find(x => x.InterviewItemCode === itemCheck.InterviewItemCode);
        if (itemDisp !== undefined && itemDisp !== null) {
          if (!this.util.isNullOrEmpty(itemCheck.InputLoLimit) && !isNaN(Number(itemCheck.InputLoLimit))
            && Number(itemCheck.ResultValue) < Number(itemCheck.InputLoLimit)) {
            itemDisp.isErrLo = true;
            blnIsValid = false;
            this.lstItemErr.push({
              InterviewItemCode: itemDisp.InterviewItemCode,
              Pos: $('#div-' + itemDisp.InterviewItemCode)?.offset()?.top
            });
          }
          if (!this.util.isNullOrEmpty(itemCheck.InputUpLimit) && !isNaN(Number(itemCheck.InputUpLimit))
            && Number(itemCheck.ResultValue) > Number(itemCheck.InputUpLimit)) {
            itemDisp.isErrUp = true;
            blnIsValid = false;
            this.lstItemErr.push({
              InterviewItemCode: itemDisp.InterviewItemCode,
              Pos: $('#div-' + itemDisp.InterviewItemCode)?.offset()?.top
            });
          }

        }
      }
    }
    return blnIsValid;
  }

  scrollToTopItemErr() {
    if (this.lstItemErr.length > 0) {
      const topEle = _.minBy(this.lstItemErr, 'Pos');
      const ele = $('#div-' + topEle.InterviewItemCode);
      const container = $('.wrapper-body');
      const topPos = ele.offset().top + container.scrollTop();
      const bottomPos = (topPos + ele.height()) || 0;
      const topScrollPos = container.scrollTop();
      const bottomScrollPos = container.height();
      if (!(bottomPos < bottomScrollPos && topPos > topScrollPos)) {
        this.scrollToElement(container, ele);
      }
    }
  }

  scrollToElement(pContainerEle, pEleScrollTo) {
    pContainerEle.animate({
      scrollTop: pEleScrollTo.offset().top - pContainerEle.offset().top + pContainerEle.scrollTop()
    }, 500);
  }

  setDataRegis() {
    this.lstInterviewItem = [];
    this.dataAllSheet.forEach(sheet => {
      sheet.LstGrp.forEach(grp => {
        grp.lstItem.forEach(item => {
          if (this.lstInterviewItem.find(x => x.InterviewItemCode === item.InterviewItemCode) === undefined) {
            this.lstInterviewItem.push({
              InterviewSheetCode: sheet.InterviewSheetCode,
              InterviewItemCode: item.InterviewItemCode,
              HTOrgCode: this.objUserInfo.HTOrgCode,
              RsvDate: this.objUserInfo.RsvDate,
              RsvNum: this.objUserInfo.RsvNum,
              ResultCategory: item.ResultCategory,
              ResultColumnNum: item.ResultColumnNum,
              ResultValue: item.InteviewResult,
              InterviewItemType: item.InterviewItemType,
              InterviewResultType: item.InterviewResultType,
              InputLoLimit: item.InputLoLimit,
              InputUpLimit: item.InputUpLimit
            });
          }
        });
      });
    });
  }

  // 20240729 #22635 add start
  setItemValueRegis5(pItem,pGrp) {
    if (pGrp.ItemType4 !== null && pGrp.ItemType4 !== undefined) {
      pGrp.ItemType4.InteviewResult = '';
      this.setItemValueRegis(pGrp.ItemType4);
    }
    pItem.isErrLo = false;
    pItem.isErrUp = false;
    this.blnIsChangeData = true;
    const objExist = this.lstInterviewItem
      .find(x => x.ResultCategory === pItem.ResultCategory && x.ResultColumnNum === pItem.ResultColumnNum);
    if (objExist === undefined || objExist === null) {
      this.lstInterviewItem.push({
        InterviewSheetCode: this.dataDisplay.InterviewSheetCode,
        InterviewItemCode: pItem.InterviewItemCode,
        HTOrgCode: this.objUserInfo.HTOrgCode,
        RsvDate: this.objUserInfo.RsvDate,
        RsvNum: this.objUserInfo.RsvNum,
        ResultCategory: pItem.ResultCategory,
        ResultColumnNum: pItem.ResultColumnNum,
        ResultValue: pItem.InteviewResult,
        InterviewItemType: pItem.InterviewItemType,
        InterviewResultType: pItem.InterviewResultType,
        InputLoLimit: pItem.InputLoLimit,
        InputUpLimit: pItem.InputUpLimit
      });
    } else {
      objExist.ResultValue = pItem.InteviewResult;
    }
  }
  // 20240729 #22635 add end
  setItemValueRegis(pItem) {
    pItem.isErrLo = false;
    pItem.isErrUp = false;
    this.blnIsChangeData = true;
    const objExist = this.lstInterviewItem
      .find(x => x.ResultCategory === pItem.ResultCategory && x.ResultColumnNum === pItem.ResultColumnNum);
    if (objExist === undefined || objExist === null) {
      this.lstInterviewItem.push({
        InterviewSheetCode: this.dataDisplay.InterviewSheetCode,
        InterviewItemCode: pItem.InterviewItemCode,
        HTOrgCode: this.objUserInfo.HTOrgCode,
        RsvDate: this.objUserInfo.RsvDate,
        RsvNum: this.objUserInfo.RsvNum,
        ResultCategory: pItem.ResultCategory,
        ResultColumnNum: pItem.ResultColumnNum,
        ResultValue: pItem.InteviewResult,
        InterviewItemType: pItem.InterviewItemType,
        InterviewResultType: pItem.InterviewResultType,
        InputLoLimit: pItem.InputLoLimit,
        InputUpLimit: pItem.InputUpLimit
      });
    } else {
      objExist.ResultValue = pItem.InteviewResult;
    }
  }

  // check input all item(not use)
  checkIsInputAllSheet() {
    if (this.dataAllSheet.length === 0) {
      return false;
    }
    for (const sheet of this.dataAllSheet) {
      for (const grp of sheet.LstGrp) {
        if (grp.LayoutDiv === '1') {
          // check item type 3
          const lstItemType3 = grp.lstItem.filter(x => x.IsDisable === false && x.InterviewItemType === '3');
          for (const item of lstItemType3) {
            if (this.util.isNullOrEmpty(item.InteviewResult)) {
              return false;
            }
          }

          if (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode) {
            // check list setItem
            for (const setItem of grp.lstSetItem) {
              const isChecked = setItem?.find(x => x.IsDisable === false && x.InteviewResult === x.ResultCode) !== undefined;
              if (!isChecked) {
                return false;
              }
            }
            // check item type 1
            const lstItemType1 = grp.lstItemDisp
              .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '1');
            for (const item of lstItemType1) {
              const lstResult = item.lstResult.map(x => x.ResultCode);
              if (!lstResult.includes(item.InteviewResult)) {
                return false;
              }
            }
            // check item type 2
            const lstItemType2 = grp.lstItemDisp
              .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '2');
            const isCheckItemType2 = lstItemType2.find(x => x.InteviewResult === x.ResultCode) !== undefined;
            if (lstItemType2.length > 0 && !isCheckItemType2) {
              return false;
            }
          }
        }

        if (grp.LayoutDiv === '2'
          && (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode)) {
            const lstItemDisp = grp.lstItemDisp.filter(x => x.IsDisable === false);
            const isChecked = lstItemDisp.find(x => x.InteviewResult === x.ResultCode) !== undefined;
            if (lstItemDisp.length > 0 && !isChecked) {
              return false;
            }
        }

        if (grp.LayoutDiv === '3'
          && (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode)) {
          for (const item of grp.lstItemDisp.filter(x => x.IsDisable === false)) {
            const lstResult = item.lstResult.map(x => x.ResultCode);
            if (!lstResult.includes(item.InteviewResult)) {
              return false;
            }
          }
        }

        if ((grp.LayoutDiv === '4' || grp.LayoutDiv === '5')
          && (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode)) {
          for (const setItem of grp.lstSetItem) {
            const isChecked = setItem?.find(x => x.IsDisable === false && x.InteviewResult === x.ResultCode) !== undefined;
            if (!isChecked) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  // InputCheckDiv = 1: 1 or more items required
  // InputCheckDiv = 2: All items must be entered
  // InputCheckDiv = 3: Not subject to check
  checkIsInputAllSheetByInputCheckDiv() {
    if (this.dataAllSheet.length === 0 || this.lstInterviewItem.length === 0) {
      return true;
    }
    for (const sheet of this.dataAllSheet) {
      for (const grp of sheet.LstGrp.filter(x => x.InputCheckDiv === '1' || x.InputCheckDiv === '2')) {
        if ((grp.LayoutDiv === '2' || grp.LayoutDiv === '3' || grp.LayoutDiv === '4' || grp.LayoutDiv === '5')
          && (grp.ItemType4 !== null && grp.ItemType4 !== undefined && grp.ItemType4.InteviewResult === grp.ItemType4.ResultCode)) {
          continue;
        }
        const lstItemDisp = grp.lstItemDisp.filter(x => x.IsDisable === false);
        if (lstItemDisp.length === 0) {
          continue;
        }
        // InputCheckDiv = 1
        if (grp.InputCheckDiv === '1') {

          if (grp.LayoutDiv === '1') {
            // type 3
            let isNotInputAllSetItem = false;
            let isNotInputAllType1 = false;
            let isNotInputAllType2 = false;
            const lstItemType3 = grp.lstItem.filter(x => x.IsDisable === false && x.InterviewItemType === '3');
            const isNotInputAllType3 =
              lstItemType3.length > 0 && lstItemType3.find(x => !this.util.isNullOrEmpty(x.InteviewResult)) === undefined;

            if (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode) {
              // check list setItem
              isNotInputAllSetItem = grp.lstSetItem.length > 0 && grp.lstSetItem.find(setItem =>
                  setItem?.find(it => it.IsDisable === false && it.InteviewResult === it.ResultCode) !== undefined) === undefined;

              // type 1
              const lstItemType1 = grp.lstItemDisp
                .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '1');
              isNotInputAllType1 = lstItemType1.length > 0
                && lstItemType1.find(it => it.lstResult.map(x => x.ResultCode).includes(it.InteviewResult)) === undefined;

              // type 2
              const lstItemType2 = grp.lstItemDisp
                .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '2');
              isNotInputAllType2 = lstItemType2.length > 0 && lstItemType2.find(x => x.InteviewResult === x.ResultCode) === undefined;
            }
            if (isNotInputAllType1 && isNotInputAllType2 && isNotInputAllType3 && isNotInputAllSetItem) {
              return false;
            }
          }
          if (grp.LayoutDiv === '2') {
            const isNotCheckedAll = lstItemDisp.find(x => x.InteviewResult === x.ResultCode) === undefined;

            if (isNotCheckedAll) {
              if(grp.lstItemType5.length > 0){
                if(this.util.isNullOrEmpty(grp.lstItemType5[0].InteviewResult)){
                  return false;
                }
              }
            }
          }

          if (grp.LayoutDiv === '3') {
            const isNotCheckedAll = lstItemDisp.find(it => it.lstResult.map(x => x.ResultCode).includes(it.InteviewResult)) === undefined;

            if (isNotCheckedAll) {
              if(grp.lstItemType5.length > 0){
                if(this.util.isNullOrEmpty(grp.lstItemType5[0].InteviewResult)
                && this.util.isNullOrEmpty(grp.lstItemType5[1].InteviewResult)
                && this.util.isNullOrEmpty(grp.lstItemType5[2].InteviewResult)){
                  return false;
                }
              }
            }
          }

          if (grp.LayoutDiv === '4' || grp.LayoutDiv === '5') {
            let lstItemCheck = [];
            grp.lstSetItem.forEach(setItem => {
              lstItemCheck = lstItemCheck.concat(setItem.filter(x => x.IsDisable === false));
            });

            const isNotCheckedAll = lstItemCheck.find(x => x.InteviewResult === x.ResultCode) === undefined;
            if (isNotCheckedAll) {
              if(grp.lstItemType5.length > 0){
                if(this.util.isNullOrEmpty(grp.lstItemType5[0].InteviewResult)
                && this.util.isNullOrEmpty(grp.lstItemType5[1].InteviewResult)
                && this.util.isNullOrEmpty(grp.lstItemType5[2].InteviewResult)
                && this.util.isNullOrEmpty(grp.lstItemType5[3].InteviewResult)){
                  return false;
                }
              }
            }
          }
        }

        // InputCheckDiv = 2
        if (grp.InputCheckDiv === '2') {

          if (grp.LayoutDiv === '1') {
            // type 3
            const lstItemType3 = grp.lstItem.filter(x => x.IsDisable === false && x.InterviewItemType === '3');
            const isOneItemNotInputType3 =
              lstItemType3.length > 0 && lstItemType3.find(x => this.util.isNullOrEmpty(x.InteviewResult)) !== undefined;
            if (isOneItemNotInputType3) {
              return false;
            }

            if (grp.ItemType4 === null || grp.ItemType4 === undefined || grp.ItemType4.InteviewResult !== grp.ItemType4.ResultCode) {
              for (const setItem of grp.lstSetItem) {
                const isOneItemNotChecked = setItem.find(x => x.InteviewResult === x.ResultCode) === undefined;
                if (isOneItemNotChecked) {
                  return false;
                }
              }

              // type 1
              const lstItemType1 = grp.lstItemDisp
                .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '1');
              const isOneItemNotInputType1 =
                lstItemType1.find(it => !it.lstResult.map(x => x.ResultCode).includes(it.InteviewResult)) !== undefined;
              if (isOneItemNotInputType1) {
                return false;
              }

              // type 2
              const lstItemType2 = grp.lstItemDisp
                .filter(x => x.IsDisable === false && this.util.isNullOrEmpty(x.InterviewSetItemCode) && x.InterviewItemType === '2');
              const isOneItemNotInputType2 = lstItemType2.find(x => x.InteviewResult !== x.ResultCode) !== undefined;
              if (isOneItemNotInputType2) {
                return false;
              }
            }
          }

          if (grp.LayoutDiv === '2') {
            const isOneItemNotChecked = lstItemDisp.find(x => x.InteviewResult !== x.ResultCode) !== undefined;
            if (isOneItemNotChecked) {
              return false;
            }
          }
          if (grp.LayoutDiv === '3') {
            const isOneItemNotChecked =
              lstItemDisp.find(it => !it.lstResult.map(x => x.ResultCode).includes(it.InteviewResult)) !== undefined;
            if (isOneItemNotChecked) {
              return false;
            }
          }
          if (grp.LayoutDiv === '4' || grp.LayoutDiv === '5') {
            for (const setItem of grp.lstSetItem) {
              const isOneItemNotChecked = setItem.find(x => x.InteviewResult === x.ResultCode) === undefined;
              if (isOneItemNotChecked) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  }

  onClickBtnBack() {
    if (this.blnIsChangeData === true) {
      const msg = this.translate.instant('MESS_CNF_SAVE_CHANGED');
      this.dialogModalService.openVerificationModal(msg).subscribe(res => {
        if (res.isOk()) {
          this.onClickBtnRegis('/toppage');
        } else if (res.isNo()) {
          this.blnIsChangeData = false;
          this.router.navigateByUrl('/toppage');
        }
      });
    } else {
      this.router.navigateByUrl('/toppage');
    }
  }
  @HostListener('window:resize', ['$event'])
  setRowAnswer() {
    const hW = $('.row-dynamic').width() / 2;
    $('.col-dynamic').each(function () {
        if ($(this).width() > hW){
          $(this).closest('.row-dynamic').addClass('full-dynamic');
        } else {
          $(this).closest('.row-dynamic').removeClass('full-dynamic');
        }
    });
  }

  ngAfterViewInit(): void {
    this.hideFixedBtn();
    this.setRowAnswer();
  }

  resetRadioVal(pCheckedVal, pCurrentVal, pItem, pGrp) {
    if (pGrp.InputCheckDiv?.trim() === '1' && pCheckedVal === pCurrentVal) {
      pItem.InteviewResult = '';
      this.setItemValueRegis(pItem);
      this.setShowHideChildItem(pItem, '');
    }
  }
}
